define(function (require, exports) {
    'use strict';

    exports.listItemLoading = function () {
        return {
            restrict: 'E',
            scope: true,
            replace: true,
            template: '<div class="text-center" ng-show="loading"> <i class="fa fa-2x fa-spinner fa-spin"></i> </div>'
        };
    };
});



// WEBPACK FOOTER //
// ./scripts/directives/listItemLoading.js